import { useMutation } from '@tanstack/react-query';
import { Button } from '../../components/ui/button';
import { syncZernioProfilesNow } from './api';

// Admin button on Sync Health. The Zernio profile cache feeds every pull's
// roster; an account connected since the last successful sync reads as
// "profile-missing-from-cache" and is skipped. Shows the returned stats, or the
// failure reason (the sync refuses to write on a bad read, and says why).
export function RefreshZernioProfiles() {
  const m = useMutation({ mutationFn: syncZernioProfilesNow });
  return (
    <div className="mb-6 flex flex-wrap items-center gap-3 text-sm">
      <Button type="button" variant="outline" size="sm" disabled={m.isPending} onClick={() => m.mutate()}>
        {m.isPending ? 'Refreshing…' : 'Refresh Zernio profiles'}
      </Button>
      {m.data && (
        <span className="text-muted-foreground">
          {m.data.profilesFound} profiles · {m.data.profilesNew} new · {m.data.profilesUpdated} updated ·{' '}
          {m.data.profilesDeleted} removed
        </span>
      )}
      {m.isError && (
        <span className="text-red-600">
          Refresh failed: {m.error instanceof Error ? m.error.message : 'unknown error'}
        </span>
      )}
    </div>
  );
}
